import produce from 'immer';

// TYPES
import { Types, AtualizarSigla } from './types';
import { ReducerActionRotaSP } from '../../../../../types';

export const INITIAL_STATE: AtualizarSigla = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): AtualizarSigla {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZAR_SIGLA_REQUEST: {
				draft.status = INITIAL_STATE.status;
				break;
			}

			case Types.ATUALIZAR_SIGLA_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.ATUALIZAR_SIGLA_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.ATUALIZAR_SIGLA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
